import Vue from 'vue'
import Router from 'vue-router'
import register from './views/Register.vue'
import dashboard from './views/Dashboard.vue'
import QRCode from './views/QRCode.vue'
import workshop from './views/Workshop.vue'
import login from './views/Login.vue'
import logout from './views/Logout.vue'
import profile from './views/Profile.vue'
// import formworkshop from './views/Formworkshop.vue'
import staffPage from './views/staffPage.vue'
import staff_dashboard from './components/staffdashboard.vue'
import staff_scan from './components/staffscan.vue'
import store from './store.js'

Vue.use(Router)

let router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/test',
      name: 'test',
      component: () => import('./views/walk-in.vue')
    },
    {
      path: '/',
      name: 'login',
      component: login,
      alias: '/login'
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/created',
      name: 'created',
      component: QRCode,
      props: true,
      alias: '/qrcode'
    },
    {
      path: '/workshop',
      name: 'workshop',
      component: workshop,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: dashboard,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: profile,
    },
    {
      path: '/staff',
      component: staffPage,
      children: [
        {
          path: 'dashboard',
          component: staff_dashboard
        },
        {
          path: 'scan',
          component: staff_scan
        },
        {
          path: '',
          component: staff_dashboard,
          alias: ':id'
        }
      ],
      meta: { 
        requiresAuth: true,
        restrictedArea: true
      }
    },
    
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/login',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      if (to.matched.some(record => record.meta.restrictedArea)) {
        if (store.getters.getUsername[0] === 'S') {
          next()
        } else {
          next({
            path: '/dashboard',
            params: {
              nextUrl: to.fullPath
            }
          })
        }
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router